export default function notUndefinedOrNull(value) {
    return value !== undefined && value !== null;
}
